// extracted by mini-css-extract-plugin
export default {"component":"EditServiceSection_component__qgnWd","buttonContainer":"EditServiceSection_buttonContainer__vyhym","buttonGap":"EditServiceSection_buttonGap__qbw9y"};